module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "login"
  }, [_c('Row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('Col', {
    staticClass: "form"
  }, [_c('h3', [_vm._v("停车王需求管理系统")]), _vm._v(" "), _c('Form', {
    ref: "loginForm",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.loginRule
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "user"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.loginForm.user),
      callback: function($$v) {
        _vm.loginForm.user = $$v
      },
      expression: "loginForm.user"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-person-outline"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.loginForm.password = $$v
      },
      expression: "loginForm.password"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-locked-outline"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Checkbox', {
    staticStyle: {
      "float": "left"
    },
    model: {
      value: (_vm.loginForm.remember),
      callback: function($$v) {
        _vm.loginForm.remember = $$v
      },
      expression: "loginForm.remember"
    }
  }, [_vm._v("记住密码")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loginLoading,
      "icon": "log-in"
    },
    on: {
      "click": function($event) {
        _vm.loginPost('loginForm')
      }
    }
  }, [_vm._v("登录\n          ")])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-a5cb9644","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 17
// module chunks = 0